/* eslint-disable jira/filename-case */
import { fg } from '@atlassian/jira-feature-gating';

const JiraAiAgentAvatarWithApptypeForJqlRelayProvider = {
	get(): boolean {
		return fg('jira_ai_agent_avatar_with_apptype_for_jql');
	},
};

export default JiraAiAgentAvatarWithApptypeForJqlRelayProvider;
